import axios from 'axios';

// Dedicated client for the kiosk. Kept separate from the main app client so
// a kiosk session on a shared tablet never touches an admin's localStorage
// auth. Kiosk tokens live in sessionStorage and expire on the server after
// the configured timeout -- there is no refresh; expiry returns the tablet
// to the PIN screen.

const kioskClient = axios.create({
  baseURL: 'https://api.traceoperations.com',
});

kioskClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('kiosk_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const kioskLogout = () => {
  sessionStorage.removeItem('kiosk_token');
  sessionStorage.removeItem('kiosk_user');
};

export default kioskClient;